import * as Log from "web-ui/log"
import { morphdomIgnore } from "web-ui/morphdom/ignore"
import { morphdomPreserveAttributes } from "web-ui/morphdom/preserve-attributes"
import { resetOptions } from "web-ui/tom-select/reset-options"

export function TurboMorphSyncPlugin() {
  const tomSelect = this

  tomSelect.hook("before", "setup", () => {
    tomSelect.input.addEventListener("morphdom:updated", synchronizeTomSelect)

    morphdomPreserveAttributes(tomSelect.input, ["class", "tabindex"])
    morphdomIgnore(tomSelect.wrapper, true)
  })

  tomSelect.on("focus", () => {
    morphdomIgnore(tomSelect.input, true)
  })

  tomSelect.on("blur", () => {
    if (tomSelect.isFocused) {
      return
    }

    morphdomIgnore(tomSelect.input, false)
  })

  function synchronizeTomSelect(event) {
    const element = event.target

    requestAnimationFrame(() => {
      const value = element.value

      debug("Synchronizing", { disabled: element.disabled, value: value, children: debugChildren(element) })

      if (element.disabled) {
        tomSelect.disable()
      } else {
        tomSelect.enable()
      }

      resetOptions(element, tomSelect)
    })
  }

  function debugChildren(element) {
    return Array.from(element.children).map((child) => {
      if (child.tagName === "OPTGROUP") {
        return {
          tagName: child.tagName,
          label: child.label,
          children: debugChildren(child)
        }
      } else {
        return {
          tagName: child.tagName,
          value: child.value,
          text: child.text,
          selected: child.selected
        }
      }
    })
  }

  function debug(message, data) {
    Object.assign(data, {
      id: tomSelect.input.id
    })

    Log.debug("Tom Select Morphdom Plugin - " + message, data)
  }
}
